import LocaleStorageKey from '@/enums/locale-storage-key';

function setDataToLocaleStorage(dataKey: LocaleStorageKey, dataValue: string | number | boolean = ''): void {
  try {
    localStorage.setItem(dataKey, dataValue?.toString());
  } catch (error: any) {
    console.error(`Ошибка при сохранении истории ${error.toString()}`);
  }

}

export default setDataToLocaleStorage;
